import { FormFamilyMemberResponse } from 'src/modules/member/models/formFamilyMemberResponse';
import { FormMemberPost } from 'src/modules/member/models/formMemberPost';
import AxiosInstance from 'src/shared/services/axios/interceptor';

const controller = 'FormFamilyMember';

export const getFormFamilyMember = (mainMemberId: number, formName: string) => {
  const endpoint = `${controller}/New?mainMemberId=${mainMemberId}&formName=${formName}`;
  return AxiosInstance.get<FormFamilyMemberResponse>(endpoint);
};

export const createFormFamilyMember = (member: FormMemberPost) => {
  const endpoint = `${controller}`;
  return AxiosInstance.post<FormMemberPost>(endpoint, member);
};
